module.exports = __webpack_public_path__ + "static/media/4.8e02d38d.jpg";